// extracted by css-extract-rspack-plugin
export default {"Heading":"SidebarHeading-module__Heading__NlDdTAn"};